import React, { useContext, useEffect, useState } from "react";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
  Button,
  RSelect
} from "../../../../components/Component";

import UserProfileAside from "./UserProfileAside";
import { countryOptions, userData } from "../../../pre-built/user-manage/UserData";

import { Card } from "antd";
import { Link } from "react-router-dom";
const SelfSetupStepByStep = () => {
  const [sm, updateSm] = useState(false);
  const [mobileView , setMobileView] = useState(false);
  
  const [modalTab, setModalTab] = useState("1");
  const [userInfo, setUserInfo] = useState(userData[0]);
  const [formData, setFormData] = useState({
    name: "Abu Bin Ishtiak",
    displayName: "Ishtiak",
    phone: "818474958",
    dob: "1980-08-10",
    address: "2337 Kildeer Drive",
    address2: "",
    state: "Kentucky",
    country: "Canada",
  });
  const [modal, setModal] = useState(false);

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitForm = () => {
    let submitData = {
      ...formData,
    };
    setUserInfo(submitData);
    setModal(false);
  };

  // function to change the design view under 990 px
  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    document.getElementsByClassName("nk-header")[0].addEventListener("click", function () {
      updateSm(false);
    });
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);
  
  return (
    <React.Fragment>
      <Head title="Self setup step by step"></Head>
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                sm ? "content-active" : ""
              }`}
            >
              <UserProfileAside updateSm={updateSm} sm={sm} />
            </div>
            <div className="card-inner card-inner-lg">
              {sm && mobileView && <div className="toggle-overlay" onClick={() => updateSm(!sm)}></div>}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">Setup guide</BlockTitle>
                    <BlockDes>
                      <p>Follow this guide and start sending in minutes.</p>
                    </BlockDes>
                  </BlockHeadContent>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""}`}
                      onClick={() => updateSm(!sm)}
                    >
                      <Icon name="menu-alt-r"></Icon>
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>

              <Block>
              <div className="bq-note">
                     
                          <div className="bq-note-item" >
                            <h4>Step 1</h4>
                            <div className="bq-note-text">
                              <p>Download our android app from <a href="https://textlinksms.com/textlink.apk" style={{color:"blue"}}>here</a>.</p>
                            </div>
                         
                          </div>
                          <div className="bq-note-item" >
                          <h4>Step 2</h4>
                            <div className="bq-note-text">
                              <p>Log in with your TextLink account, read the terms and understand how it works.</p>
                            </div>
                         
                          </div>
                          <div className="bq-note-item" >
                          <h4>Step 3</h4>
                            <div className="bq-note-text">
                              <p>Choose which countries you want to send to and tick all the options you want (you will understand once you get the app).</p>
                            </div>
                         
                          </div>
                         
                                        
                       </div>
              </Block>

            
            </div>
          </div>
        </Card>
      </Content>
    </React.Fragment>
  );
};

export default SelfSetupStepByStep;
